<template>
  <img
    src="@/assets/apple.png"
    alt=""
    class=""
  >
</template>
